import classNames from 'classnames/bind';
import { SkeletonLine } from 'koba/components/SkeletonPost';

import React from 'react';

import EventCardSkeleton from '../EventCardSkeleton/EventCardSkeleton';
import styles from './EventsSkeleton.module.scss';

const cx = classNames.bind(styles);

interface EventsSkeletonProps {
  renderHeader?: boolean;
}

const EventsSkeleton: React.FC<EventsSkeletonProps> = ({ renderHeader = true }) => {
  return (
    <div className={cx('events-skeleton__container')} data-qa="events-skeleton">
      {renderHeader && (
        <div className={cx('events-skeleton__header')}>
          <SkeletonLine height="40px" width="60px" />
          <SkeletonLine height="40px" width="60px" />
        </div>
      )}
      <div className={cx('events-skeleton__cards')}>
        <EventCardSkeleton />
        <EventCardSkeleton />
        <EventCardSkeleton />
        <EventCardSkeleton />
      </div>
    </div>
  );
};

export default EventsSkeleton;
